<div class="create-dialog-container">
  <!-- Modal Header -->
  <div class="modal-header">
    <h2 class="modal-title">{{ data.title }}</h2>
    @if (data.hasClose) {
      <button
        mat-icon-button
        [mat-dialog-close]="false"
        class="close-button"
        aria-label="Close"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <!-- Modal Content -->
  <div class="modal-content">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ data.label }}</mat-label>
      <input
        matInput
        [attr.placeholder]="data.placeholder"
        [(ngModel)]="data.model"
      />
    </mat-form-field>
  </div>

  <!-- Modal Actions -->
  <div class="modal-actions">
    @if (data.confirmCaption) {
      <button class="confirm-button" [mat-dialog-close]="data">
        {{ data.confirmCaption }}
      </button>
    }
    @if (data.cancelCaption) {
      <button class="cancel-button" [mat-dialog-close]="false">
        {{ data.cancelCaption }}
      </button>
    }
  </div>
</div>
